import apiClient from "../common/apiClient.js";

export default class AddressController {
  async Create(data, token) {
    try {
      return await apiClient.post("/tenant/address", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Update(data, token) {
    try {
      return await apiClient.put("/tenant/address", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }

  async Get(tenantId, token) {
    try {
      return await apiClient.get("/tenant/address/" + tenantId, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
}
